(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.onScrollHandler = this.onScroll.bind(this);
      this.onResizeHandler = this.onResize.bind(this);
      this.hideHeaderOnScrollUp = () => { this.preventReveal = true; };
      this.header = null;
      this.headerBounds = { top: 0, bottom: 0 };
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.isScrolling = null;
      this.predictiveSearch = null;
      this.resizeObserver = null;
      this.mobileQuery = window.matchMedia('(max-width: 989px)');
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      if (!this.header) return;

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size' ||
        this.mobileQuery.matches;

      this.predictiveSearch = this.querySelector('predictive-search');
      this.setHeaderHeight();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
        this.header.classList.remove('shopify-section-header-hidden');
      }

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      window.addEventListener('resize', this.onResizeHandler, { passive: true });
      this.mobileQuery.addEventListener('change', this.onResizeHandler);

      this.createObserver();
      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
      this.mobileQuery.removeEventListener('change', this.onResizeHandler);
      if (this.resizeObserver) this.resizeObserver.disconnect();
      window.clearTimeout(this.isScrolling);
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    onResize() {
      if (!this.header) return;
      this.setHeaderHeight();

      if (this.mobileQuery.matches) {
        this.header.classList.add('shopify-section-header-sticky');
        this.header.classList.remove('shopify-section-header-hidden', 'animate');
        this.header.style.removeProperty('transform');
        this.header.style.removeProperty('visibility');
        this.header.style.removeProperty('opacity');
        this.headerIsAlwaysSticky = true;
      } else {
        this.headerIsAlwaysSticky =
          this.getAttribute('data-sticky-type') === 'always' ||
          this.getAttribute('data-sticky-type') === 'reduce-logo-size';

        if (!this.headerIsAlwaysSticky) {
          this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
        }
      }

      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    }

    createObserver() {
      if (!this.header) return;

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.setHeaderHeight());
        this.resizeObserver.observe(this.header);
      }

      const observer = new IntersectionObserver((entries) => {
        if (entries.length) this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (!this.header || !this.header.isConnected) return;

      const scrollTop = Math.max(0, window.pageYOffset || document.documentElement.scrollTop || 0);

      /* On mobile, never apply the hide-on-scroll class. */
      if (this.mobileQuery.matches) {
        this.header.classList.add('shopify-section-header-sticky');
        this.header.classList.remove('shopify-section-header-hidden', 'animate');
        this.header.style.removeProperty('transform');
        this.header.style.removeProperty('visibility');
        this.header.style.removeProperty('opacity');
        this.currentScrollTop = scrollTop;
        return;
      }

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (document.documentElement.classList.contains('bbm-menu-locked')) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(() => this.hide());
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(() => this.reveal());
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(() => this.hide());
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(() => this.reset());
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (!this.header || this.mobileQuery.matches || this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (!this.header) return;
      if (this.mobileQuery.matches || this.headerIsAlwaysSticky) {
        this.header.classList.remove('shopify-section-header-hidden');
        return;
      }
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (!this.header) return;
      if (this.mobileQuery.matches || this.headerIsAlwaysSticky) {
        this.header.classList.remove('shopify-section-header-hidden');
        return;
      }
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      if (!this.header) return;
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((item) => {
        if (typeof item.close === 'function') item.close();
      });
    }

    closeSearchModal() {
      if (!this.header) return;
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && typeof this.searchModal.close === 'function') this.searchModal.close(false);
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  /* Desktop only: close sibling dropdowns when another opens. */
  (() => {
    const initExclusiveMenus = () => {
      document.querySelectorAll('.header__inline-menu').forEach((root) => {
        if (root.dataset.bbmExclusiveInit === 'true') return;
        root.dataset.bbmExclusiveInit = 'true';

        const siblings = (details) => {
          const list = details.closest('ul');
          if (!list) return [];
          return Array.from(list.children)
            .map((li) => li.querySelector(':scope > details'))
            .filter((item) => item && item !== details);
        };

        const closeTree = (details) => {
          details.querySelectorAll('details[open]').forEach((child) => child.removeAttribute('open'));
          details.removeAttribute('open');
        };

        root.addEventListener('toggle', (event) => {
          const details = event.target;
          if (!(details instanceof HTMLDetailsElement) || !details.open) return;
          siblings(details).forEach(closeTree);
        }, true);

        root.addEventListener('click', (event) => {
          const summary = event.target.closest('summary');
          if (!summary || !root.contains(summary)) return;
          const details = summary.parentElement;
          if (!(details instanceof HTMLDetailsElement)) return;
          siblings(details).forEach(closeTree);
        }, true);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initExclusiveMenus, { once: true });
    } else {
      initExclusiveMenus();
    }
    document.addEventListener('shopify:section:load', initExclusiveMenus);
  })();

  /* Mobile drawer lock: prevent the page behind the open drawer from scrolling. */
  (() => {
    const html = document.documentElement;
    let locked = false;
    let savedScrollY = 0;
    let observer = null;

    const getDetails = () => document.querySelector('header-drawer > details, header-drawer details');
    const isOpen = (details) => !!details && (details.hasAttribute('open') || details.classList.contains('menu-opening'));

    const lockPage = () => {
      if (locked) return;
      locked = true;
      savedScrollY = window.scrollY || window.pageYOffset || 0;
      html.classList.add('bbm-menu-locked');
      document.body.style.position = 'fixed';
      document.body.style.top = `-${savedScrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
    };

    const unlockPage = () => {
      if (!locked) return;
      locked = false;
      html.classList.remove('bbm-menu-locked');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      window.scrollTo(0, savedScrollY);
    };

    const sync = () => {
      const details = getDetails();
      if (isOpen(details)) lockPage();
      else unlockPage();
    };

    const init = () => {
      const details = getDetails();
      if (!details) return;
      if (observer) observer.disconnect();

      observer = new MutationObserver(sync);
      observer.observe(details, { attributes: true, attributeFilter: ['open', 'class'] });
      details.addEventListener('toggle', sync);
      sync();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
